import { supabase } from "@/integrations/supabase/client";

/**
 * Wraps fetch() and attaches the current Supabase access token as a Bearer
 * authorization header. Pass this as the `fetch` option to authed
 * createServerFn calls so the `requireSupabaseAuth` middleware sees the token.
 */
export async function authedFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  const headers = new Headers(init?.headers);
  if (token && !headers.has("authorization")) {
    headers.set("authorization", `Bearer ${token}`);
  }
  return fetch(input, { ...init, headers });
}
